module.exports = __webpack_public_path__ + "static/media/axs-white.38019a17.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/axs-white.png
// module id = 553
// module chunks = 11